import { ListeTable } from '@mairistem/liste';
import _ from 'lodash';
import React from 'react';

import { RegieContext } from '@/contexts';

type FacturesImpayeesListeTableHeaderProps = {
  [key: string]: any;
};

const FacturesImpayeesListeTableHeader = (props: FacturesImpayeesListeTableHeaderProps) => {
  const { ...rest } = props;

  const { regies, selectedRegie } = React.useContext(RegieContext);

  const { logicielsFacturier } = _.find(regies, { identifiant: selectedRegie }) || {};

  // Si 1 seul logiciel facturier, on masque la colonne
  const hideSourceColumn = _.size(logicielsFacturier) <= 1;

  return (
    <>
      <ListeTable.Column {...rest} name="numero" verticalAlign="middle" style={{ width: 175 }}>
        N°
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="nomPayeur" verticalAlign="middle">
        Nom du payeur
      </ListeTable.Column>
      <ListeTable.Column
        {...rest}
        name="dateEmission"
        verticalAlign="middle"
        style={{ width: 150 }}
      >
        Date d&apos;émission
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="dateLimite" verticalAlign="middle" style={{ width: 150 }}>
        Date limite
      </ListeTable.Column>
      {!hideSourceColumn && (
        <ListeTable.Column {...rest} name="source" style={{ width: 90 }} verticalAlign="middle">
          App
        </ListeTable.Column>
      )}
      <ListeTable.Column {...rest} name="montant" style={{ width: 130 }} verticalAlign="middle">
        Montant
      </ListeTable.Column>
      <ListeTable.Column {...rest} name="resteAPayer" style={{ width: 130 }} verticalAlign="middle">
        Reste à payer
      </ListeTable.Column>
    </>
  );
};

export default FacturesImpayeesListeTableHeader;
